import {getAuth, GoogleAuthProvider, signInWithPopup} from "firebase/auth";

export const ingresarConGoogle = async () => {

    const auth = getAuth();
    auth.languageCode = 'es';

    const provider = new GoogleAuthProvider();

    return signInWithPopup(auth, provider)
        .then((result) => {
            const credential = GoogleAuthProvider.credentialFromResult(result);
            return credential
        }).catch((error) => {
            console.log(error.message)
            return null
        });
}